export function isValidEvent(ev: any) {
  return (
    ev.id ||
    ev.pd_dispense_record_link ||
    ev.pd_summary_id ||
    ev.pd_prescription_record_link ||
    ev.pd_dispense_id ||
    ev.pd_prescription_id
  );
}
